export default __webpack_public_path__ + "static/media/196.3ff9fe46.jpg";